/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-reset': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M11.25 17.5a7.5 7.5 0 10-7.5-7.5v3.875l-2.25-2.25-.875.875 3.75 3.75 3.75-3.75-.875-.875L5 13.875V10a6.25 6.25 0 116.25 6.25v1.25z"/>'
  }
})
